import { createRouter, createWebHistory, type Router } from 'vue-router';

import HomeView from '../views/HomeView.vue';
import ReviewDetailView from '../views/ReviewDetailView.vue';
import ReviewListView from '../views/ReviewListView.vue';
import ReviewStackView from '../views/ReviewStackView.vue';

export function createAppRouter(basePath: string): Router {
  return createRouter({
    history: createWebHistory(basePath),
    routes: [
      { path: '/', name: 'home', component: HomeView },
      { path: '/reviews/:reviewType', name: 'reviews', component: ReviewListView, props: true },
      {
        path: '/reviews/:reviewType/stack',
        name: 'review-stack',
        component: ReviewStackView,
        props: (route) => ({
          reviewType: route.params.reviewType,
          ids: String(route.query.ids ?? '')
            .split(',')
            .filter(Boolean),
        }),
      },
      { path: '/reviews/:reviewType/:id', name: 'review-detail', component: ReviewDetailView, props: true },
    ],
  });
}
